import { updatePrice } from "../helpers/updateBookingSummary"
import { formatMoney } from "../helpers/formatMoney"
import { getBooking } from '../api/getBooking'

let paymentOptions
let bookingNumber
let bookingOptions
let payInFullElement
let depositElement
let depositDisabledElement
let paymentInfoContainer
let accordionElement

window.addEventListener("DOMContentLoaded", (event) => {
  if (isBooking()) {
    getHtmlElements()
    trackBookingOptions()
    document.addEventListener("holiday-park-booking:updated", (customEvent) => {
      updatePaymentOptionDisplay(customEvent?.detail?.booking ?? {})
    })

    // document.addEventListener('click', event => {
    //   const isClickInside = paymentOptions.contains(event.target)

    //   if (!isClickInside) {
    //     closeAccordion()
    //   }
    // })
  }
})

const getHtmlElements = () => {
  paymentOptions = document.querySelector(".payment-options")
  bookingNumber = document.querySelector("#holiday-park-booking-page").dataset.booking_id
  bookingOptions = paymentOptions.querySelector(".payment-options-deposit")
  payInFullElement = bookingOptions.querySelector(".pay-in-full")
  depositElement = bookingOptions.querySelector(".deposit")
  depositDisabledElement = bookingOptions.querySelector(".deposit-disabled")
  paymentInfoContainer = document.querySelector("#payment-info")
  accordionElement = paymentOptions.querySelector("#accordion")
}

function isBooking() {
  return document.querySelector("#booking-info")
}

const clearSelectedOptions = () => {
  payInFullElement.classList.remove("selected", "grayed-out")
  depositElement.classList.remove("selected", "grayed-out")
}

const selectOption = async (deposit = false) => {
  if (deposit && depositElement?.style?.display === "none") {
    deposit = false
  }

  clearSelectedOptions()
  if (deposit) {
    depositElement.classList.add("selected")
    payInFullElement.classList.add("grayed-out")
  }
  else {
    payInFullElement.classList.add("selected")
    depositElement.classList.add("grayed-out")
  }
  const price = await updatePrice(bookingNumber, deposit)
  updateAccordion(price, deposit)
  paymentInfoContainer.querySelector("#paying_deposit").value = deposit ? "true" : "false"
}

const updateAccordion = (price, deposit) => {
  accordionElement.querySelector("#text-content").textContent = (deposit ? "Deposit - " : "Pay in Full - ") + price
}

const toggleAccordion = () => {
  const arrowUp = paymentOptions.querySelector("#arrow-up")
  accordionElement.classList.toggle("active")
  bookingOptions.classList.toggle("active")
  if (bookingOptions.style.maxHeight) {
    bookingOptions.style.maxHeight = null;
    arrowUp.classList.remove("rotate-180")
  } else {
    bookingOptions.style.maxHeight = "100%";
    arrowUp.classList.add("rotate-180")
  }
}

const closeAccordion = () => {
  const arrowUp = paymentOptions.querySelector("#arrow-up")
  accordionElement.classList.remove("active")
  bookingOptions.classList.remove("active")
  bookingOptions.style.maxHeight = null;
  arrowUp.classList.remove("rotate-180")
}

const openAccordion = () => {
  const paymentOptions = document.querySelector(".payment-options")
  const accordionElement = paymentOptions.querySelector("#accordion")
  const bookingOptions = paymentOptions.querySelector(".payment-options-deposit")
  const arrowUp = paymentOptions.querySelector("#arrow-up")
  arrowUp.classList.add("rotate-180")

  accordionElement.classList.add("active")
  bookingOptions.classList.add("active")
  bookingOptions.style.maxHeight = "100%";
}

async function trackBookingOptions() {
  await refreshPaymentOptions()

  // accordionElement.addEventListener("click", () => {
  //   toggleAccordion()
  // })

  depositElement.addEventListener("click", () => {
    selectOption(true)
  })

  payInFullElement.addEventListener("click", () => {
    selectOption()
  })

  if (!paymentInfoContainer.querySelector("#paying_deposit").value) {
    selectOption(false)
  }
}

const refreshPaymentOptions = async () => {
  const booking = await getBooking(bookingNumber)
  updatePaymentOptionDisplay(booking?.booking ?? {})
}

const updatePaymentOptionDisplay = (booking = {}) => {
  const state = depositState(booking)
  const depositSelected = paymentInfoContainer?.querySelector("#paying_deposit")?.value === "true"
  const fullPrice = formatMoney(booking.checkout_total_price ?? booking.total_price)
  const fullPaymentMessage = state.fullPaymentMessage ?? ""

  if (payInFullElement) {
    payInFullElement.querySelector("#full-price").textContent = fullPrice
    payInFullElement.querySelector("#security-deposit-message").textContent = fullPaymentMessage
    payInFullElement.querySelector("#security-deposit-message").style.display = fullPaymentMessage ? "block" : "none"
  }

  if (state.valid) {
    showElement(depositElement)
    hideElement(depositDisabledElement)
    depositElement.querySelector("#deposit-price").textContent = state.depositAmount
    depositElement.querySelector("#deposit-balance").textContent = state.remainingBalance
    depositElement.querySelector("#deposit-due-date").textContent = state.dueDate
    updateAccordion(depositSelected ? state.depositAmount : fullPrice, depositSelected)
    return
  }

  hideElement(depositElement)
  showElement(depositDisabledElement)
  depositDisabledElement.querySelector("#message").textContent = state.message
  updateAccordion(fullPrice, false)

  if (paymentInfoContainer?.querySelector("#paying_deposit")?.value === "true") {
    selectOption(false)
  }
}

const depositState = (booking = {}) => {
  const depositAmountValue = parseMoney(booking.deposit_amount)
  const totalPriceValue = parseMoney(booking.total_price)
  const depositAllowed = Boolean(booking.deposit_allowed)
  const finalPaymentDueDate = booking.final_payment_due_date_display ?? ''

  if (depositAllowed && depositAmountValue > 0) {
    const remainingBalance = Math.max(totalPriceValue - depositAmountValue, 0)

    return {
      valid: true,
      depositAmount: formatMoney(depositAmountValue),
      remainingBalance: formatMoney(remainingBalance),
      dueDate: finalPaymentDueDate,
    }
  }

  return {
    valid: false,
    message: booking.security_deposit_due_now
      ? `This booking requires full payment today, including the refundable security deposit of ${formatMoney(booking.security_deposit_amount ?? 0)}.`
      : "This booking requires full payment today.",
    fullPaymentMessage: booking.security_deposit_due_now
      ? `Includes the refundable security deposit of ${formatMoney(booking.security_deposit_amount ?? 0)} because arrival is within 48 hours.`
      : "",
  }
}

const parseMoney = (value) => {
  const numericValue = parseFloat(String(value ?? "").replace(/,/g, ""))

  return Number.isNaN(numericValue) ? 0 : numericValue
}

const hideElement = (element) => {
  element.style.display = "none"
}

const showElement = (element) => {
  element.style.display = "block"
}

export { selectOption }
